import React from "react";
import { Tabs, Text, Group, Button, Stack } from "@mantine/core";
import { Page } from "../../layout/page";
import ExtraFieldListEditor from "../../components/extraField/ExtraFieldListEditor";

function ExtraFields() {
  return (
    <Page hideTitle>
      <Tabs defaultValue="user" keepMounted={false}>
        <Tabs.List>
          <Tabs.Tab value="user">User</Tabs.Tab>
          <Tabs.Tab value="client">Client</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="user" mt="md">
          <ExtraFieldListEditor entityType="User" />
        </Tabs.Panel>
        <Tabs.Panel value="client" mt="md">
          <ExtraFieldListEditor entityType="Client" />
        </Tabs.Panel>
      </Tabs>
    </Page>
  );
}

export default ExtraFields;
